import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    setItem<T>(value: T, key: string): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    getItem<T>(key: string, defaultValue: T): T {
        try {
            const item: string | null = localStorage.getItem(key);
            return item ? JSON.parse(item) : defaultValue;
        } catch (e) {
            return defaultValue;
        }
    }

    removeItem(key: string): void {
        localStorage.removeItem(key);
    }

}
